import { PSMSIndicatorMetric } from "@src/middleware/services/psms/psmsIndicator.service";
import { PSMS_INIT, PSMS_FETCH_CLAIMS_REQUEST, PSMS_FETCH_CLAIMS_SUCCESS, PSMS_FETCH_CLAIMS_FAILURE, PSMS_MCR_INVENTORY_REQUEST, PSMS_MCR_INVENTORY_SUCCESS, PSMS_MCR_INVENTORY_FAILURE, PSMS_MCR_INVENTORY_LOADING, PSMS_EXTENDED_TIN_DETAIL_SUCCESS, SET_PSMS_FILTERS, GET_PSMS_INDICATOR_SUCCESS } from "../../actions/actionTypes";

export interface PsmsClaimsState {
  psmsState: any | null;
  loading: boolean;
  data: any;
  error: string | null;
  currentFilters: any; // Add currentFilters to the state
  extendedTinDetail: any; // Add extendedTinDetail to the state
  psmsIndicatorData?: PSMSIndicatorMetric[];
}


const initialState: PsmsClaimsState = {
  psmsState: null,
  loading: false,
  data: null,
  error: null,  
  currentFilters: {}, // Add currentFilters to the state
  extendedTinDetail: {}, // Add extendedTinDetail to the state
  psmsIndicatorData: [] as PSMSIndicatorMetric[],
};


export default function psmsReducer(state: PsmsClaimsState = initialState, action: any): PsmsClaimsState {
  switch (action.type) {
    case PSMS_INIT:
      return { ...state, psmsState: action.payload };
    case PSMS_FETCH_CLAIMS_REQUEST:
      return { ...state, loading: true, data: null, error: null };
    case PSMS_FETCH_CLAIMS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case PSMS_FETCH_CLAIMS_FAILURE:
      return { ...state, loading: false, data: null, error: action.error };
    case PSMS_EXTENDED_TIN_DETAIL_SUCCESS:
      return { ...state, extendedTinDetail: action.payload };
    case SET_PSMS_FILTERS:
      return { ...state, currentFilters: action.payload };
    case GET_PSMS_INDICATOR_SUCCESS:
      return { ...state, psmsIndicatorData: action.payload?.Data ?? action.payload ?? [] };
    default:
      return state;
  }
}